import React from 'react';
import './style.scss';

export default function FileStep({ content = [] }) {
  return <ul className="file-step">
    {
      content.map(([text, extra = null], index) => <li key={index}>
        <p className="file-step-text">{text}</p>
        <div className="file-step-extra">
          {extra}
        </div>
      </li>)
    }
  </ul>
}